import { Link } from "react-router-dom";
import { Instagram, Facebook, MapPin, Phone, Clock, Mail } from "lucide-react";
import BrandMark from "./BrandMark";

const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-ink text-beige mt-24">
      <div className="container-luxe py-20">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <BrandMark size="md" inverted />
            <p className="mt-6 text-beige/70 leading-relaxed text-sm max-w-sm">
              Especialista em Balayage e coloração capilar. Cada visita é uma experiência
              de transformação cuidadosamente criada para si.
            </p>
            <div className="flex gap-3 mt-8">
              <a
                href="https://www.instagram.com/tamaraalveshairstylist/"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-instagram"
                className="w-10 h-10 border border-gold/40 flex items-center justify-center text-gold hover:bg-gold hover:text-ink transition-all"
                aria-label="Instagram"
              >
                <Instagram className="w-4 h-4" strokeWidth={1.5} />
              </a>
              <a
                href="https://www.facebook.com/"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-facebook"
                className="w-10 h-10 border border-gold/40 flex items-center justify-center text-gold hover:bg-gold hover:text-ink transition-all"
                aria-label="Facebook"
              >
                <Facebook className="w-4 h-4" strokeWidth={1.5} />
              </a>
            </div>
          </div>

          <div className="lg:col-span-3">
            <h4 className="overline mb-6 !text-gold">Navegação</h4>
            <ul className="space-y-3 text-sm text-beige/80">
              <li><Link to="/sobre" className="hover:text-gold transition-colors">Sobre Tamara</Link></li>
              <li><Link to="/servicos" className="hover:text-gold transition-colors">Serviços</Link></li>
              <li><Link to="/galeria" className="hover:text-gold transition-colors">Galeria</Link></li>
              <li><Link to="/loja" className="hover:text-gold transition-colors">Pre-Shop Cotril</Link></li>
              <li><Link to="/agendamentos" className="hover:text-gold transition-colors">Agendamentos</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-5">
            <h4 className="overline mb-6 !text-gold">Visite-nos</h4>
            <ul className="space-y-4 text-sm text-beige/85">
              <li className="flex gap-3">
                <MapPin className="w-4 h-4 text-gold flex-shrink-0 mt-0.5" strokeWidth={1.5} />
                <span>Rua Casal dos Ninhos, 2D<br />2665-536 Venda do Pinheiro, Portugal</span>
              </li>
              <li className="flex gap-3">
                <Phone className="w-4 h-4 text-gold flex-shrink-0 mt-0.5" strokeWidth={1.5} />
                <a href="tel:+351910327990" className="hover:text-gold transition-colors">+351 910 327 990</a>
              </li>
              <li className="flex gap-3">
                <Mail className="w-4 h-4 text-gold flex-shrink-0 mt-0.5" strokeWidth={1.5} />
                <a href="mailto:info@tamaraalves.pt" className="hover:text-gold transition-colors">info@tamaraalves.pt</a>
              </li>
              <li className="flex gap-3">
                <Clock className="w-4 h-4 text-gold flex-shrink-0 mt-0.5" strokeWidth={1.5} />
                <span>Terça a Sábado · 09:00 — 19:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-beige/10 mt-16 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-beige/50">
          <p>© {new Date().getFullYear()} Tamara Alves Hairstylist. Todos os direitos reservados.</p>
          <p>
            Website desenvolvido por{" "}
            <a
              href="https://www.alpenpro.agency"
              target="_blank"
              rel="noreferrer"
              data-testid="alpen-credit-link"
              className="text-gold hover:underline font-medium"
            >
              Alpen Pro Agency
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
